import { axiosInstance } from "../../../Services";


export const AddInventorySource = async (id, data) => {
  try {
    const res = await axiosInstance.post(
      `/rsform/inventories/source/${id}`,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          "x-api-key": localStorage.getItem("token"),
        },
      }
    );
    return res.data; // important: return API response
  } catch (err) {
    throw err;
  }
};

export const GetInventorySources = async (id) => {
  try {
    const res = await axiosInstance.get(`/rsform/inventories/source/${id}`);
    return res.data?.data;
  } catch (err) {
    throw err;
  }
};

// Approve / Reject a source (design approval)
// approval_status: "approved" | "declined"
// approval_comment: optional
export const ApproveInventorySource = async (
  versionId,
  sourceId,
  { approval_status, approval_comment }
) => {
  try {
    const formData = new FormData();
    formData.append("approval_status", approval_status);
    formData.append("approval_type", "source");
    if (approval_comment) {
      formData.append("approval_comment", approval_comment);
    }

    const res = await axiosInstance.post(
      `/rsform/inventories/designApproval/${versionId}/${sourceId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          "x-api-key": localStorage.getItem("token"),
        },
      }
    );
    return res.data;
  } catch (err) {
    throw err;
  }
};